import { maxRecaptchaWaitTime, checkRecaptchaTime } from '../globals/globals';

declare const window;

export const getReCaptchaToken = async (action: string) => {
  const grecaptcha = window.grecaptcha.enterprise;

  const token = await grecaptcha.execute(window.ProgConnect.recapSiteKey, { action });

  return token;
};

export const waitForRecaptcha = (timeout = maxRecaptchaWaitTime): Promise<void> => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const checkRecaptcha = () => {
      if (window.grecaptcha?.enterprise) {
        window.grecaptcha.enterprise.ready(resolve);

        return;
      }

      if (Date.now() - startTime > timeout) {
        reject(new Error('reCAPTCHA failed to load within timeout'));

        return;
      }

      setTimeout(checkRecaptcha, checkRecaptchaTime);
    };

    checkRecaptcha();
  });
};

export const whenRecaptchaReady = (callback: () => void): void => {
  waitForRecaptcha()
    .then(callback)
    /*eslint-disable-next-line no-console */
    .catch(() => console.warn('reCAPTCHA failed to load within timeout'));
};
